import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Bundle } from 'fhir/r4';
import { map, Observable } from 'rxjs';
import { ApiService } from '../../api';
import { ArrivalBoardConfiguration } from '../entities/arrival-board-configuration';
import { ArrivalBoardItem } from '../entities/arrival-board-item';
import { ArrivalBoardDataSource } from './arrival-board-data-source';
import { mapBundleToItems } from './fhir-bundle.mapper';
import { joinUrl } from './join-url';

/** Fallback when the HAL root lacks the link; the href is the same template (no `templated` flag). */
const BOARD_PATH_TEMPLATE = 'arrival-board/{boardId}';

const BOARD_ID_PLACEHOLDER = '{boardId}';

/**
 * One poll is one `GET arrival-board/{boardId}` returning a raw FHIR searchset, shaped by
 * {@link mapBundleToItems}. Errors are not caught: the page classifies them by status.
 */
@Service({ autoProvided: false })
export class HttpArrivalBoardDataSource extends ArrivalBoardDataSource {
    private readonly http = inject(HttpClient);
    private readonly apiService = inject(ApiService);

    fetch(config: ArrivalBoardConfiguration): Observable<ArrivalBoardItem[]> {
        return this.http
            .get<Bundle>(this.boardUrl(config.uuid))
            .pipe(map((bundle) => mapBundleToItems(bundle, config.columns)));
    }

    /** Resolved per call: a field would freeze the URL before `ApiService.init()` has resolved the root. */
    private boardUrl(boardId: string): string {
        const href = this.apiService.rootResponseSignal()?._links?.arrivalBoard?.href ?? BOARD_PATH_TEMPLATE;
        return joinUrl(this.apiService.urlSignal(), href.replace(BOARD_ID_PLACEHOLDER, boardId));
    }
}
